<template>
    <div>
        <ShelterTable />
    </div>
</template>

<script>
import ShelterTable from '@/components/shelter/ShelterTable.vue'
export default {
    components: {
        ShelterTable
    },
    name: 'Shelters'
}
</script>